import { env } from '@/app/env';

/**
 * «Now» for relative times. Fixtures mode pins it to the design's moment (Thursday 29 October 2026,
 * 14:35 in Tashkent) so «12 мин», «вчера», «Истекает через 5 дн» render exactly as in the design.
 */
export const FIXTURES_NOW = new Date('2026-10-29T14:35:00+05:00');

export function now(): Date {
  return env.fixtures ? new Date(FIXTURES_NOW) : new Date();
}
